import React from "react";
import { SheetContent, SheetTrigger } from "@/components/ui/sheet";
import SvgClose from "../../assets/icons/SvgClose";
import { Link } from "gatsby";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types";
import { GatsbyImage } from "gatsby-plugin-image";

export const options = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, children) => (
      <Link
        to={node.data.uri}
        className="text-white hover:scale-105 duration-200"
      >
        {children}
      </Link>
    ),
    [MARKS.BOLD]: (text, children) => <b>{children}</b>,
    [MARKS.UNDERLINE]: (text, children) => (
      <span className="underline-offset-8">{children}</span>
    ),
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <p className="text-sm tracking-wide mb-[10px] whitespace-pre-wrap leading-[1.75]">
        {children}
      </p>
    ),

    [BLOCKS.HEADING_3]: (node, children) => (
      <h3 className="font-semibold mt-5 mb-2 underline-offset-4">{children}</h3>
    ),
    [BLOCKS.HEADING_5]: (node, children) => (
      <h3 className="font-semibold mt-5 mb-2 underline-offset-4 hover:scale-[1.04] duration-200">
        {children}
      </h3>
    ),
    [BLOCKS.HEADING_6]: (node, children) => (
      <h3 className="font-semibold mt-5 mb-2 underline-offset-4">{children}</h3>
    ),
  },
};

export default function HelpLinks({
  title,
  bgImage,
  helpLinks = [],
  footerLinks = [],
  contactDetails,
}) {
  return (
    <SheetContent
      side="top"
      noOverlay
      className="border-b-0 hidden md:block p-0"
    >
      <SheetTrigger
        asChild
        className="absolute text-white text-[10px] top-[50px] z-[2] right-[50px] hover:text-secondary-500 cursor-pointer"
        role="button"
      >
        <SvgClose />
      </SheetTrigger>
      <div className="absolute inset-0 w-full h-full z-0">
        <GatsbyImage
          image={bgImage.gatsbyImageData}
          alt={bgImage.title}
          className="w-full h-full object-cover"
          loading="lazy"
          objectFit="cover"
        />
      </div>
      <div className="lg:pl-14 2xl:pl-[90px] py-[50px] text-white relative z-[1] bg-black/50 w-full h-full">
        <div className="flex justify-between py-[50px] px-5 gap-5 tracking-wide">
          <div className="flex flex-col w-full pr-2">
            {title && (
              <h5 className="text-xl lg:text-2xl text-white mb-[30px] font-semibold tracking-wide">
                {title}
              </h5>
            )}
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-y-10 gap-x-10">
              {helpLinks.map((link) => (
                <Link
                  key={link.id}
                  to={link.slug}
                  className="max-w-[350px] w-full border border-solid border-white h-20 lg:h-[128px] rounded-xl py-5 px-5 xl:px-10 text-center flex 
                  items-center justify-center hover:scale-105 duration-200"
                >
                  <h3 className="text-base lg:text-xl font-medium">
                    {link.title}
                  </h3>
                </Link>
              ))}
            </div>
            <div className="flex items-center justify-center space-x-2 text-sm lg:text-base font-normal mt-20">
              {footerLinks.map((link, index) => (
                <div key={index}>
                  <Link
                    to={link.slug}
                    id={link.id}
                    className="hover:text-secondary-500"
                  >
                    {link.title}
                  </Link>
                  {index !== footerLinks.length - 1 && (
                    <span className="ml-2">|</span>
                  )}
                </div>
              ))}
            </div>
          </div>
          {/* RIght */}
          <div className="pl-10 w-[320px] whitespace-pre-wrap border-l border-solid border-l-white">
            {documentToReactComponents(JSON.parse(contactDetails.raw), options)}
          </div>
        </div>
      </div>
    </SheetContent>
  );
}
